export const USE_STARTUP_DATA_FROM_EXTENSION = false;
